import { styled } from '@mui/material/styles';
import { Box, Button, Select } from '@mui/material';

export const TableContainerCardBox = styled(Box)(({ theme }) => ({
  marginBottom: '1.5rem',
  backgroundColor: theme.palette.background.bgwhite,
  // transition: 'all 0.5s ease-in-out',
  position: 'relative',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.custom.borderColor}`,
  boxShadow:
    theme.palette.mode === 'light'
      ? '0px 4.4px 12px -1px rgba(222, 222, 222, 0.36)'
      : 'none',
  color: 'inherit',
  margin: '16px',
 overflowX: 'hidden',
 

}));

export const GradientButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(to right, #8f01ff, #a743f8)',
  color: '#fff',
  fontWeight: 600,
  fontSize: '16px',
  padding: '12px 0',
  borderRadius: '8px',
  textTransform: 'none',
  border: 'none',
  cursor: 'pointer',
  '&:hover': {
    background: 'linear-gradient(90deg, #a743f8 0%, #8f01ff 100%)',
  },
}));
export const StyledSelect = styled(Select)(({ theme }) => ({
  maxWidth: 67,
  height: 40,
  fontSize: 14,
  borderRadius: 8,
  backgroundColor: theme.palette.background.bgwhite,
  padding: '4px 10px',
  borderWidth:'1px',
  borderStyle:'solid',
  borderColor: theme.palette.custom.borderColor,
  '& .MuiSelect-select': {
    paddingRight:'0px',
        height: '100% !important',
    minHeight: 'unset !important',
    textOverflow: 'unset !important',
    whiteSpace: 'unset !important',
    overflow: 'unset !important',
    display: 'flex',
    alignItems: 'center',
  },
  '& fieldset': {
    borderColor: '#e0e0e0',
  },
}));
